<template>
    <Box :title="'盘点单(' + Total + '条)'" :SearchParams="IsSee" @SearchParams="IsSee = true">
        <transition-group name="fade">
            <div class="menu" key='1' v-show="IsSee">
                <Field title="盘点单号" placeholder="请输入盘点单号" @onMessage="value => search.InventoryNo = value" />

                <Field title="时间类型" placeholder="请选择" :text='search.TimeType' type='popup'
                    :data="['全部', '盘点日期', '审核日期']" @confirm="search.TBBZ = arguments[0]" />
                <Field title="盘点状态" :tabSelected="search.InventoryState"
                    @onMessage="(value) => (search.InventoryState = value.id)" :data="[
                        { id: '', name: '全部' },
                        { id: '0', name: '盘点中' },
                        { id: '1', name: '未审核' },
                        { id: '2', name: '已审核' }
                    ]" type="teb" />
                <Field title="开始时间" placeholder="请选择" type="calendar" @onMessage="value => search.StartDate = value" />
                <Field title="结束时间" placeholder="请选择" type="calendar" @onMessage="value => search.EndDate = value" />
                <div class="search" @click="serach">查询</div>
            </div>
        </transition-group>
        <LoadingFooter v-model="loading" :finished="finished" @load="onLoad" @scroll="IsSee = false">
            <div class="ArrayItems items" v-for="item in list"
                @click="$router.push({ name: 'InventoryDetail', params: { item} })">
                <div>
                    <img src="@/assets/img/Icon_1.png" />
                    <div>
                        <div>
                            <span class="ellipsis">{{ item.InventoryNo }}</span>
                            <img src="../../assets/img/right.png" />
                        </div>
                        <div>
                            <div>
                                <p>盘点单号:</p>
                                <p>盘点人：</p>
                                <p>盘点日期：</p>
                                <p>备注：</p>
                            </div>
                            <div>
                                <p class="ellipsis">{{ item.InventoryNo }}</p>
                                <p class="ellipsis">{{ item.InventoryUserName }}</p>
                                <p class="ellipsis">{{ item.InventoryTime }}</p>
                                <p class="ellipsis">{{ item.Remarks }}</p>
                            </div>
                            <div class="button">
                                <div @click.stop="Delete(item.InventoryNo)">删除</div>
                                <div v-if="item.InventoryState == 0" @click.stop="SubmitOrVerify(item.InventoryNo, 1)">提交
                                </div>
                                <div v-if="item.InventoryState == 1" @click.stop="SubmitOrVerify(item.InventoryNo, 2)">取消提交
                                </div>
                                <div v-if="item.InventoryState == 1" @click.stop="SubmitOrVerify(item.InventoryNo, 3)">审核
                                </div>
                                <div v-if="item.InventoryState == 2" @click.stop="SubmitOrVerify(item.InventoryNo, 4)">取消审核
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <span>盘点状态</span>
                    <span>{{ FormatState(item.InventoryState) }}</span>
                </div>
            </div>
        </LoadingFooter>
    </Box>
</template>

<script>
    import {
        ExistsEdorIng
    } from "../../../tool/api/api.js";
    import {
        Tab,
        Tabs
    } from "vant";
    import Box from "@/components/commonBox/commonBox";
    import Field from "../../components/field/field";
    import LoadingFooter from "../../components/loadingFooter/loadingFooter";
    export default {
        name: "InventoryList",
        data() {
            return {
                search: {
                    SBMC: null,
                    StartDate: null,
                    EndDate: null,
                    InventoryState: ''
                },
                loading: true,
                finished: false,
                list: [],
                touchStartY: 0,
                IsSee: false,
                page: 10,
                Total: 0
            };
        },
        components: {
            Box,
            Field,
            LoadingFooter,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
        },
        activated() {
            this.serach();
        },
        methods: {
            serach() {
                this.IsSee = false;
                this.page = 10;
                this.LoadInventory();
            },
            onLoad() {
                if (!this.loading && !this.finished) {
                    this.page += 1;
                    this.LoadInventory();
                }
            },
            LoadInventory() {
                this.$post('api/Inventory/GetInventoryList', {
                    PageIndex: 1,
                    PageSize: this.page,
                    InventoryNo: this.search.InventoryNo,
                    TimeType: this.search.TimeType == "盘点日期" ? '1' : this.search.TimeType == '审核日期' ? '2' : '1',
                    StartDate: this.search.StartDate,
                    EndDate: this.search.EndDate,
                    StoreId: this.$UserInfo.StoreCode,
                    UserCode: this.$UserInfo.UserId,
                    InventoryState: this.search.InventoryState,
                    Token: ''
                }).then(result => {
                    this.Total = result.Total;
                    this.list = result.InventoryList;
                    if (this.list.length < this.page) {
                        this.loading = false;
                        this.finished = true;
                    } else {
                        this.finished = false;
                        this.loading = false;
                    }
                });
            },
            FormatState(value) {
                if (value == '0') {
                    return '盘点中';
                } else if (value == '1') {
                    return '未审核';
                } else if (value == '2') {
                    return '已审核';
                }
            },
            SubmitOrVerify(value, type) {
                this.$Dialog.confirm({
                    message: this.FormatMsg(type),
                }).then(() => {
                    this.$get("api/Inventory/SubmitOrVerify", {
                        InventoryNo: value,
                        SubmitType: type,
                        UserId: this.$UserInfo.UserId
                    }).then((result) => {
                        if (result.Status) {
                            this.$Toast({
                                message: result.Msg,
                                duration: 1500
                            });
                            location.reload();
                        } else this.$Toast(result.Msg);
                    });
                    // this.LoadInventory();

                }).catch(() => {});
            },
            Delete(value) {
                this.$Dialog.confirm({
                    message: "是否删除盘点单?",
                }).then(() => {
                    this.$get('api/Inventory/DeletePD', {
                        InventoryNo: value
                    }).then(result => {
                        if (result.Status) {
                            this.$Toast({
                                message: result.Msg,
                                duration: 1500
                            });
                        } else this.$Toast(result.Msg);
                    });
                }).catch(() => {});
            },
            FormatMsg(type) {
                if (type == 1) {
                    return '是否确认提交盘点单？';
                } else if (type == 2) {
                    return '是否确认取消提交盘点单？';
                } else if (type == 3) {
                    return '审核之后将改变当前资产信息,是否确定审核盘点单？';
                } else if (type == 4) {
                    return '审核之后将还原当前资产信息,是否确定审核盘点单？';
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;
        margin-top: 100px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #f3f3f3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-bottom: 20px;

        &>div {
            &:first-child {
                display: flex;
                padding: 34px 16px 27px 26px;
                box-sizing: border-box;
                border-bottom: 2px solid #efefef;

                img {
                    width: 150px;
                    height: 150px;
                    border-radius: 4px;
                }

                &>div {
                    &:nth-child(2) {
                        margin-left: 16px;
                        flex: 1;

                        &>div {
                            display: flex;

                            &:first-child {
                                margin-bottom: 18px;
                                display: flex;

                                span:first-child {
                                    color: $TEXT-DARK-COLOR;
                                    font-weight: bold;
                                    font-size: 32px;
                                    flex: 1;
                                    width: 208px;
                                }

                                span:nth-child(2) {
                                    color: $TEXT-DARK-COLOR;
                                    font-size: 28px;
                                    margin-left: 10px;
                                    width: 158px;
                                    text-align: right;
                                }

                                img {
                                    width: 32px;
                                    height: 32px;
                                    margin-left: 10px;
                                }
                            }

                            &:nth-child(2) {
                                p {
                                    color: #999;
                                    font-size: 26px;
                                    line-height: 45px;
                                    height: 45px;
                                }

                                &>div:nth-child(2) {
                                    p {
                                        width: 200px;
                                    }
                                }
                            }
                        }

                        .button {
                            margin-left: 10px;
                            margin-bottom: 0px;

                            div {
                                width: 152px;
                                height: 60px;
                                border-radius: 30px;
                                background: $THEME-COLOR;
                                font-size: 26px;
                                color: #fff;
                                text-align: center;
                                line-height: 60px;
                                margin-bottom: 12px;
                            }
                        }
                    }
                }
            }

            &:last-child {
                margin-top: 16px;
                padding: 0 26px 0 31px;
                box-sizing: border-box;
                display: flex;

                span {
                    color: #999;
                    font-size: 26px;

                    &:first-child {
                        flex: 1;
                    }
                }
            }
        }
    }

    .listLength {
        font-size: 29px;
        color: #4a4a4a;
        margin-bottom: 18px;
        margin-left: 30px;

        span {
            margin-left: 20px;
            color: $THEME-COLOR;
            font-weight: bold;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/Inventory/InventoryList.vue